import { useEffect, useMemo, useState } from 'react';

import { ExternalLink } from '@uikit';

import type { DeserializedUser } from '@api';

import { nextProjectUrl } from '@shared/constants/urls';

import * as Dialog from '@radix-ui/react-dialog';
interface CheckRequireProps {
  user: DeserializedUser | null | undefined;
  checkForData?: 'wallet';
}

const CheckRequireUserData = ({ user, checkForData = 'wallet' }: CheckRequireProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const isHasData = useMemo(() => {
    if (!user) {
      return true;
    }

    if (checkForData === 'wallet' && user) {
      const isHaveEvmWallet = user?.wallets.find((wallet) => wallet.attributes.network === 'EVM');
      return !!isHaveEvmWallet;
    }

    return true;
  }, [user, checkForData]);

  useEffect(() => {
    if (!isHasData) {
      setIsOpen(true);
    }
  }, [isHasData]);

  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Portal>
        <Dialog.Overlay forceMount className="msq-dialog msq-dialog-animate msq-dialog-default">
          <Dialog.Content
            forceMount
            aria-describedby={undefined}
            onEscapeKeyDown={(event) => event.preventDefault()}
            onPointerDownOutside={(event) => event.preventDefault()}
            className="msq-dialog-content msq-dialog-content-md"
          >
            <div className="msq-dialog-header">
              <Dialog.Title className="msq-dialog-title">EVM Wallet Needed</Dialog.Title>
            </div>
            <div className="msq-dialog-body">
              To access this feature, please connect an EVM-compatible wallet to your MagicID.
            </div>
            <div className="msq-dialog-footer msq-dialog-buttons">
              <ExternalLink
                className="msq-btn msq-btn-primary msq-btn-lg"
                href={nextProjectUrl.store('/profile/settings')}
                target="_self"
              >
                Connect Wallet
              </ExternalLink>
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CheckRequireUserData;
